import { render, staticRenderFns } from "./bulma_oneImageHtml.vue?vue&type=template&id=e450a2c4&scoped=true"
import script from "./bulma_oneImageHtml.vue?vue&type=script&lang=js"
export * from "./bulma_oneImageHtml.vue?vue&type=script&lang=js"
import style0 from "./bulma_oneImageHtml.vue?vue&type=style&index=0&id=e450a2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e450a2c4",
  null
  
)

export default component.exports